import { Api } from "../Api";

export async function getAssociateCoachingFeatureStatus() {
  const response = await Api.get("/me/coaching-dashboard/status");
  return response.data;
}

export async function getAssociateCoachingPeriods() {
  const response = await Api.get("/periods", {
    params: { scope: "manager_engagement", granularity: "rolling_28d" },
  });
  return response.data;
}

export async function getAssociateCoachingDashboard({ periodId, jobClass, frameworkFamily } = {}) {
  const params = {};
  if (periodId) params.period_id = periodId;
  if (jobClass) params.job_class = jobClass;
  if (frameworkFamily) params.framework_family = frameworkFamily;
  const response = await Api.get("/me/coaching-dashboard", { params });
  return response.data;
}

export async function refreshAssociateCoachingSummary({ periodId, jobClass, frameworkFamily }) {
  const params = { job_class: jobClass, framework_family: frameworkFamily };
  if (periodId) params.period_id = periodId;
  const response = await Api.post("/me/coaching-dashboard/summary-refresh", null, { params });
  return response.data;
}

export async function getMyCoachingGoals(status) {
  const response = await Api.get("/me/coaching-goals", {
    params: status ? { goal_status: status } : {},
  });
  return response.data;
}

export async function getMyCoachingFeedback(limit = 20) {
  const response = await Api.get("/me/coaching-feedback", { params: { limit } });
  return response.data;
}
